var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};

// polyfills/mediastreamtrackgenerator.js
var require_mediastreamtrackgenerator = __commonJS({
  "polyfills/mediastreamtrackgenerator.js"() {
    "use strict";
    if (!window.MediaStreamTrackGenerator) {
      window.MediaStreamTrackGenerator = class MediaStreamTrackGenerator {
        constructor({ kind }) {
          if (kind == "video") {
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d", { desynchronized: true });
            const track = canvas.captureStream().getVideoTracks()[0];
            track.writable = new WritableStream({
              write(frame) {
                canvas.width = frame.displayWidth;
                canvas.height = frame.displayHeight;
                ctx.drawImage(frame, 0, 0, canvas.width, canvas.height);
                frame.close();
              }
            });
            return track;
          } else if (kind == "audio") {
            const ac = new AudioContext();
            const dest = ac.createMediaStreamDestination();
            const [track] = dest.stream.getAudioTracks();
            track.writable = new WritableStream({
              async start(_controller) {
                this.arrays = [];
                function worklet() {
                  registerProcessor(
                    "mstg-shim",
                    class Processor extends AudioWorkletProcessor {
                      constructor() {
                        super();
                        this.arrays = [];
                        this.arrayOffset = 0;
                        this.port.onmessage = ({ data }) => this.arrays.push(data);
                        this.emptyArray = new Float32Array(0);
                      }
                      process(inputs, [[output]]) {
                        for (let i = 0; i < output.length; i++) {
                          if (!this.array || this.arrayOffset >= this.array.length) {
                            this.array = this.arrays.shift() || this.emptyArray;
                            this.arrayOffset = 0;
                          }
                          output[i] = this.array[this.arrayOffset++] || 0;
                        }
                        return true;
                      }
                    }
                  );
                }
                await ac.audioWorklet.addModule(`data:text/javascript,(${worklet.toString()})()`);
                this.node = new AudioWorkletNode(ac, "mstg-shim");
                this.node.connect(dest);
                return track;
              },
              write(audioData) {
                const array = new Float32Array(audioData.numberOfFrames * audioData.numberOfChannels);
                audioData.copyTo(array, { planeIndex: 0 });
                this.node.port.postMessage(array, [array.buffer]);
                audioData.close();
              }
            });
            return track;
          }
        }
      };
    }
  }
});

// polyfills/mediastreamtrackprocessor.js
var require_mediastreamtrackprocessor = __commonJS({
  "polyfills/mediastreamtrackprocessor.js"() {
    "use strict";
    if (!self.MediaStreamTrackProcessor) {
      self.MediaStreamTrackProcessor = class MediaStreamTrackProcessor {
        constructor({ track }) {
          if (track.kind == "video") {
            this.readable = new ReadableStream({
              async start(_controller) {
                this.video = document.createElement("video");
                this.video.srcObject = new MediaStream([track]);
                await Promise.all([
                  this.video.play(),
                  new Promise((r) => this.video.onloadedmetadata = r)
                ]);
                this.track = track;
                this.canvas = new OffscreenCanvas(this.video.videoWidth, this.video.videoHeight);
                this.ctx = this.canvas.getContext("2d", { desynchronized: true });
                this.t1 = performance.now();
              },
              async pull(controller) {
                while (performance.now() - this.t1 < 1e3 / track.getSettings().frameRate) {
                  await new Promise((r) => requestAnimationFrame(r));
                }
                this.t1 = performance.now();
                this.ctx.drawImage(this.video, 0, 0);
                controller.enqueue(new VideoFrame(this.canvas, { timestamp: this.t1 }));
              }
            });
          } else if (track.kind == "audio") {
            this.readable = new ReadableStream({
              async start(_controller) {
                this.ac = new AudioContext();
                this.arrays = [];
                function worklet() {
                  registerProcessor(
                    "mstp-shim",
                    class Processor extends AudioWorkletProcessor {
                      process(input) {
                        this.port.postMessage(input);
                        return true;
                      }
                    }
                  );
                }
                await this.ac.audioWorklet.addModule(`data:text/javascript,(${worklet.toString()})()`);
                this.node = new AudioWorkletNode(this.ac, "mstp-shim");
                this.ac.createMediaStreamSource(new MediaStream([track])).connect(this.node);
                this.node.port.addEventListener(
                  "message",
                  ({ data }) => data[0][0] && this.arrays.push(data)
                );
              },
              async pull(controller) {
                while (!this.arrays.length) await new Promise((r) => this.node.port.onmessage = r);
                const [channels] = this.arrays.shift();
                const joined = new Float32Array(channels.reduce((a, b) => a + b.length, 0));
                channels.reduce((offset, a) => (joined.set(a, offset), offset + a.length), 0);
                controller.enqueue(
                  new AudioData({
                    format: "f32-planar",
                    sampleRate: this.ac.sampleRate,
                    numberOfFrames: channels[0].length,
                    numberOfChannels: channels.length,
                    timestamp: this.ac.currentTime * 1e6 | 0,
                    data: joined,
                    transfer: [joined.buffer]
                  })
                );
              }
            });
          }
        }
      };
    }
  }
});

// src/ProcessorWrapper.ts
var ProcessorWrapper = class {
  static get isSupported() {
    return typeof MediaStreamTrackGenerator !== "undefined" && typeof MediaStreamTrackProcessor !== "undefined" && typeof VideoFrame !== "undefined";
  }
  constructor(transformer, name) {
    this.name = name;
    this.transformer = transformer;
    this.transformer.restart;
  }
  async setup(opts) {
    var _a, _b, _c, _d;
    this.source = opts.track;
    const origConstraints = this.source.getConstraints();
    await this.source.applyConstraints(__spreadProps(__spreadValues({}, origConstraints), {
      // @ts-expect-error when a mediastream track is resized and/or cropped, the `VideoFrame` will have a coded height/width of the original video size
      // this leads to a shift of the underlying video as the frame itself is being rendered with the coded size
      // but image segmentation is based on the display dimensions (-> the cropped version)
      // in order to prevent this, we force the resize mode to "none"
      resizeMode: "none"
    }));
    this.sourceSettings = this.source.getSettings();
    this.sourceDummy = opts.element;
    if (this.sourceDummy instanceof HTMLVideoElement) {
      this.sourceDummy.height = (_a = this.sourceSettings.height) != null ? _a : 300;
      this.sourceDummy.width = (_b = this.sourceSettings.width) != null ? _b : 300;
    }
    if (!(this.sourceDummy instanceof HTMLVideoElement)) {
      throw TypeError("Currently only video transformers are supported");
    }
    this.processor = new MediaStreamTrackProcessor({ track: this.source });
    this.trackGenerator = new MediaStreamTrackGenerator({
      kind: "video",
      signalTarget: this.source
    });
    this.canvas = new OffscreenCanvas(
      (_c = this.sourceSettings.width) != null ? _c : 300,
      (_d = this.sourceSettings.height) != null ? _d : 300
    );
  }
  async init(opts) {
    await this.setup(opts);
    if (!this.canvas || !this.processor || !this.trackGenerator) {
      throw new TypeError("Expected both canvas and processor to be defined after setup");
    }
    let readableStream = this.processor.readable;
    await this.transformer.init({
      outputCanvas: this.canvas,
      inputElement: this.sourceDummy
    });
    readableStream = readableStream.pipeThrough(this.transformer.transformer);
    readableStream.pipeTo(this.trackGenerator.writable).catch((e) => console.error("error when trying to pipe", e)).finally(() => this.destroy());
    this.processedTrack = this.trackGenerator;
  }
  async restart(opts) {
    await this.destroy();
    return this.init(opts);
  }
  async restartTransformer(...options) {
    this.transformer.restart(options[0]);
  }
  async updateTransformerOptions(...options) {
    this.transformer.update(options[0]);
  }
  async destroy() {
    var _a;
    await this.transformer.destroy();
    (_a = this.trackGenerator) == null ? void 0 : _a.stop();
  }
};

// src/transformers/BackgroundTransformer.ts
import * as vision from "@mediapipe/tasks-vision";

// package.json
var dependencies = {
  "@mediapipe/holistic": "0.5.1675471629",
  "@mediapipe/tasks-vision": "0.10.9"
};

// src/utils.ts
var isFirefoxBrowser = navigator.userAgent.includes("Firefox");
var isChromiumBasedBrowser = navigator.userAgent.includes("Chrome");

// src/transformers/VideoTransformer.ts
var VideoTransformer = class {
  constructor() {
    this.isDisabled = false;
  }
  async init({
    outputCanvas,
    inputElement: inputVideo
  }) {
    var _a;
    if (!(inputVideo instanceof HTMLVideoElement)) {
      throw TypeError("Video transformer needs a HTMLVideoElement as input");
    }
    this.transformer = new TransformStream({
      transform: (frame, controller) => this.transform(frame, controller)
    });
    this.canvas = outputCanvas || null;
    if (outputCanvas) {
      this.ctx = ((_a = this.canvas) == null ? void 0 : _a.getContext("2d")) || void 0;
    }
    this.inputVideo = inputVideo;
    this.isDisabled = false;
  }
  async restart({ outputCanvas, inputElement: inputVideo }) {
    this.canvas = outputCanvas || null;
    this.ctx = this.canvas.getContext("2d") || void 0;
    this.inputVideo = inputVideo;
    this.isDisabled = false;
  }
  async destroy() {
    this.isDisabled = true;
    this.canvas = void 0;
    this.ctx = void 0;
  }
};

// src/transformers/BackgroundTransformer.ts
var BackgroundProcessor = class extends VideoTransformer {
  constructor(opts) {
    super();
    this.backgroundImage = null;
    this.options = opts;
    this.update(opts);
  }
  static get isSupported() {
    return typeof OffscreenCanvas !== "undefined";
  }
  getVideoRectangle(canvas, frame) {
    const scaleWidth = canvas.width / frame.displayWidth;
    const scaleHeight = canvas.height / frame.displayHeight;
    const scaleFactor = Math.min(scaleWidth, scaleHeight);
    const width = frame.displayWidth * scaleFactor;
    const height = frame.displayHeight * scaleFactor;
    const { x, y } = this.centerRectangle(canvas.width, canvas.height, width, height);
    return { width, height, x, y };
  }
  centerRectangle(outerWidth, outerHeight, innerWidth, innerHeight) {
    return {
      x: (outerWidth - innerWidth) / 2,
      y: (outerHeight - innerHeight) / 2
    };
  }
  async init({ outputCanvas, inputElement: inputVideo }) {
    var _a, _b, _c, _d, _e;
    await super.init({ outputCanvas, inputElement: inputVideo });
    const fileSet = await vision.FilesetResolver.forVisionTasks(
      (_b = (_a = this.options.assetPaths) == null ? void 0 : _a.tasksVisionFileSet) != null ? _b : `https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@${dependencies["@mediapipe/tasks-vision"]}/wasm`
    );
    this.imageSegmenter = await vision.ImageSegmenter.createFromOptions(fileSet, {
      baseOptions: __spreadValues({
        modelAssetPath: (_d = (_c = this.options.assetPaths) == null ? void 0 : _c.modelAssetPath) != null ? _d : "https://storage.googleapis.com/mediapipe-models/image_segmenter/selfie_segmenter/float16/latest/selfie_segmenter.tflite",
        delegate: isChromiumBasedBrowser ? "GPU" : "CPU"
      }, this.options.segmenterOptions),
      runningMode: "VIDEO",
      outputCategoryMask: false,
      outputConfidenceMasks: true
    });
    if (((_e = this.options) == null ? void 0 : _e.imagePath) && !this.backgroundImage) {
      await this.loadBackground(this.options.imagePath).catch(
        (err) => console.error("Error while loading processor background image: ", err)
      );
    }
  }
  async destroy() {
    var _a;
    await super.destroy();
    await ((_a = this.imageSegmenter) == null ? void 0 : _a.close());
    this.backgroundImage = null;
  }
  async loadBackground(path) {
    const img = new Image();
    await new Promise((resolve, reject) => {
      img.crossOrigin = "Anonymous";
      img.onload = () => resolve(img);
      img.onerror = (err) => reject(err);
      img.src = path;
    });
    const imageData = await createImageBitmap(img);
    this.backgroundImage = imageData;
  }
  async transform(frame, controller) {
    var _a;
    try {
      if (this.isDisabled) {
        controller.enqueue(frame);
        return;
      }
      if (!this.canvas) {
        throw TypeError("Canvas needs to be initialized first");
      }
      const startTimeMs = performance.now();
      (_a = this.imageSegmenter) == null ? void 0 : _a.segmentForVideo(
        this.inputVideo,
        startTimeMs,
        (result) => this.segmentationResults = result
      );
      if (this.blurRadius) {
        await this.blurBackground(frame);
      } else {
        await this.drawVirtualBackground(frame);
      }
      const newFrame = new VideoFrame(this.canvas, {
        timestamp: frame.timestamp || Date.now()
      });
      controller.enqueue(newFrame);
    } finally {
      frame.close();
    }
  }
  async update(opts) {
    this.options = opts;
    if (opts.blurRadius) {
      this.blurRadius = opts.blurRadius;
    } else if (opts.imagePath) {
      await this.loadBackground(opts.imagePath);
    }
  }
  async drawVirtualBackground(frame) {
    var _a, _b;
    if (!this.canvas || !this.ctx || !this.segmentationResults || !this.inputVideo) return;
    this.ctx.save();
    this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    const frameRectangle = this.getVideoRectangle(this.canvas, frame);
    if ((_a = this.segmentationResults) == null ? void 0 : _a.confidenceMasks) {
      this.ctx.filter = "none";
      this.ctx.globalCompositeOperation = "source-out";
      const alphabitmap = await alphaCorrection(
        this.segmentationResults.confidenceMasks,
        this.canvas
      );
      (_b = this.ctx) == null ? void 0 : _b.drawImage(
        alphabitmap,
        frameRectangle.x,
        frameRectangle.y,
        frameRectangle.width,
        frameRectangle.height
      );
      if (this.backgroundImage) {
        this.ctx.drawImage(
          this.backgroundImage,
          frameRectangle.x,
          frameRectangle.y,
          frameRectangle.width,
          frameRectangle.height,
          frameRectangle.x,
          frameRectangle.y,
          frameRectangle.width,
          frameRectangle.height
        );
      } else {
        this.ctx.fillStyle = "#00FF00";
        this.ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);
      }
      this.ctx.globalCompositeOperation = "destination-over";
    }
    this.ctx.drawImage(
      frame,
      frameRectangle.x,
      frameRectangle.y,
      frameRectangle.width,
      frameRectangle.height
    );
    this.ctx.restore();
  }
  async blurBackground(frame) {
    var _a, _b, _c;
    if (!this.ctx || !this.canvas || !((_a = this.segmentationResults) == null ? void 0 : _a.confidenceMasks) || !this.inputVideo) {
      return;
    }
    this.ctx.save();
    this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    if ((_b = this.segmentationResults) == null ? void 0 : _b.confidenceMasks) {
      this.ctx.filter = "none";
      this.ctx.globalCompositeOperation = "source-out";
      const alphabitmap = await alphaCorrection(
        this.segmentationResults.confidenceMasks,
        this.canvas
      );
      (_c = this.ctx) == null ? void 0 : _c.drawImage(alphabitmap, 0, 0, this.canvas.width, this.canvas.height);
      this.ctx.globalCompositeOperation = "source-in";
      this.ctx.drawImage(frame, 0, 0, this.canvas.width, this.canvas.height);
      this.ctx.globalCompositeOperation = "destination-over";
      this.ctx.filter = `blur(${this.blurRadius}px)`;
      this.ctx.drawImage(frame, 0, 0, this.canvas.width, this.canvas.height);
      this.ctx.restore();
    }
  }
};
function alphaCorrection(confidenceMasks, canvas) {
  const result = confidenceMasks[0].getAsUint8Array();
  const videoHeight = confidenceMasks[0].height || canvas.height;
  const videoWidth = confidenceMasks[0].width || canvas.width;
  const dataArray = new Uint8ClampedArray(videoWidth * videoHeight * 4);
  const minConfidence = 0.3;
  const maxConfidence = 0.8;
  const confidenceRange = maxConfidence - minConfidence;
  const clamp = (num, min, max) => Math.min(Math.max(num, min), max);
  for (let i = 0; i < result.length; i++) {
    const confidence = result[i];
    const index = i * 4;
    dataArray[index] = confidence;
    dataArray[index + 1] = confidence;
    dataArray[index + 2] = confidence;
    const edgeAlpha = (confidence - minConfidence) / confidenceRange;
    const alpha = clamp(edgeAlpha, 0, 1);
    dataArray[index + 3] = confidence * alpha;
  }
  const dataNew = new ImageData(dataArray, videoWidth, videoHeight);
  return createImageBitmap(dataNew);
}

// src/index.ts
if (typeof MediaStreamTrackGenerator === "undefined") {
  require_mediastreamtrackgenerator();
}
if (typeof MediaStreamTrackProcessor === "undefined") {
  require_mediastreamtrackprocessor();
}
var BackgroundBlur = (blurRadius = 10, segmenterOptions) => {
  return BackgroundProcessor2({ blurRadius, segmenterOptions }, "background-blur");
};
var VirtualBackground = (imagePath, segmenterOptions) => {
  return BackgroundProcessor2({ imagePath, segmenterOptions }, "virtual-background");
};
var BackgroundProcessor2 = (options, name = "background-processor") => {
  const isTransformerSupported = BackgroundProcessor.isSupported;
  if (!isTransformerSupported) {
    throw new Error("background transformer is not supported in this browser");
  }
  const isProcessorSupported = ProcessorWrapper.isSupported;
  if (!isProcessorSupported) {
    throw new Error("processor is not supported in this browser");
  }
  const processor = new ProcessorWrapper(new BackgroundProcessor(options), name);
  return processor;
};
export {
  BackgroundBlur,
  BackgroundProcessor2 as BackgroundProcessor,
  BackgroundProcessor as BackgroundTransformer,
  ProcessorWrapper,
  VideoTransformer,
  VirtualBackground
};
//# sourceMappingURL=index.mjs.map